import { render, staticRenderFns } from "./BtDashboardDesigner.vue?vue&type=template&id=95431b10&scoped=true&"
import script from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
export * from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardDesigner.vue?vue&type=style&index=0&id=95431b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95431b10",
  null
  
)

export default component.exports